
var e4 = e4 || {},
    mch365 = mch365 || {};

( function () {
    'use strict';
    jQuery( function () {
        mch365.init();
    } );
    mch365.init = function () {
        mch365.scrollPosition.init();
        mch365.modalForms.init();
        mch365.placementTool.init();
        mch365.hasLocalNav.init();
        mch365.vocast.init();
        mch365.cookiebot.init();
    };

    /*stand: {
     number: 'J7256',
     m2Areal: 18.00,
     dimensions: {
     m2Width: 3.00,
     m2Height: 6.00
     }
     }
     */
    

    mch365.cookiebot = {
        init: function () {
            mch365.cookiebot.bindEvents();
        },
        bindEvents: function () {
            var boolOptinPreferences = false,
                boolOptinStatistics = false,
                boolOptinMarketing = false; 
            
            window.addEventListener('CookiebotOnConsentReady', function (e) {
                boolOptinPreferences = Cookiebot.consent.preferences;
                boolOptinStatistics = Cookiebot.consent.statistics;
                boolOptinMarketing = Cookiebot.consent.marketing; 
                
                console.log('CookiebotOnConsentReady');
                if ( boolOptinMarketing === true ) {
                    jQuery('.cookieconsent-optout-marketing').css('display', 'none !important');
                }
            }, false); 

            jQuery('.js-mch-change-cookie-consent-state-forms').on('click', function(e){
                console.log('click btn');
                e.preventDefault(); 
                
                boolOptinMarketing = true;

                Cookiebot.submitCustomConsent(boolOptinPreferences, boolOptinStatistics, boolOptinMarketing);
            });
        }
    };
    
    mch365.vocast = {
        pressreleaseDetail: null,
        init: function () {
            if ( jQuery('.js-mch-vocast-pressrelease-detail-container').length > 0 ){
                mch365.vocast.pressreleaseDetail = jQuery('.js-mch-vocast-pressrelease-detail-container');
                mch365.vocast.detail.sanitize();
            }
            if ( jQuery('.js-mch-pressreleases-items').length > 0 ){
                e4.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-vocast-pressreleases #js-e-handlebars-tmpl-vocast-pressreleases-pagination' );
                    e4.handlebars.registerPartials( '#js-e-handlebars-tmpl-vocast-pressreleases-item-partial' );
                    mch365.vocast.list.bindEvents();
                } );
            }
        },
        detail: {
            sanitize: function () {
                mch365.vocast.pressreleaseDetail.find('.styles_canvas').append('<div class="col_1 mt-2 small"><div class="column">'+mch365.vocast.pressreleaseDetail.find('.styles_element_attachments').closest('.column').html()+'</div></div>');
                
                const canvasImage = mch365.vocast.pressreleaseDetail.data( 'canvasImage' );
                const mainImage = mch365.vocast.pressreleaseDetail.find('.styles_element_image img:visible').first();
                if ( mainImage.length > 0 && canvasImage !== '' ){
                    const imageSrcRoot = mainImage.attr( 'src' ).split( '/file/' )[ 0 ];
                    const newImageSrc = imageSrcRoot + canvasImage;
                    mainImage.attr('src', newImageSrc);
                }
            }
        },
        list: {
            bindEvents: function(){
                jQuery('.js-mch-pressreleases-pagination').on('click', '.js-mch-vocast-pressreleases-paging-nav-item', function(event){
                    event.preventDefault();
                    jQuery('.js-mch-pressreleases-items').data('pagenum', jQuery(event.currentTarget).data('pageNum'));
                    mch365.vocast.list.populate();
                });
                mch365.vocast.list.populate();
            },
            populate: function () {
                var jElement = jQuery('.js-mch-pressreleases-items');
                mch365.vocast.list.ajax(  {
                    url: '/system/data/pressreleases',
                    data: jElement.data()
                }, function ( jsonData ) {
                    jQuery('.js-mch-pressreleases-pagination').html(e4.handlebars.tmpl.vocastPressreleasesPagination(jsonData));
                    jElement.html( e4.handlebars.tmpl.vocastPressreleases( jsonData ) );
                    jQuery('.js-vocast-pressreleases-preloader').removeClass('is-loading');
                    //jQuery.each( jsonData.pressReleases, function ( intIndex, objItem ) {
                    //    jElement.append( e4.handlebars.partial.vocastPressreleasesItemPartial( objItem.listItemHtml ) );
                    //} );
                } );
            },
            ajax: function ( objAjaxSettings, fnCallback ) {
                var jqXHR = jQuery.ajax( jQuery.extend( {
                    method: 'POST',
                    dataType: 'json',
                    cache: true,
                    beforeSend: function () {
                        jQuery('.js-vocast-pressreleases-preloader').addClass('is-loading');
                        jQuery('html, body').animate({scrollTop : 0},200);
                    }
                }, objAjaxSettings ) );
                jqXHR.done( function ( data ) {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( data );
                    }
                } );
            }
        }
    };

    mch365.hasLocalNav = {
        init: function () {
            if ( jQuery('.e-nav-local-container').length > 0 ) {
                jQuery('body').addClass('has-local-nav');
            }
        }
    };

    mch365.placementTool = {
        jPlacementCanvas: null,
        canvas: {
            originalHeight: null,
            originalWidth: null
        },
        tile:{
            width: 100,
            height: 100,
            division: {
                vertical: 3,
                horizontal: 3
            }
        },
        jLastClickedTile: null,
        zoom: {
            min: 1,
            max: 5,
            current: 1
        },
        guid: null,
        init: function(){
            if(jQuery('.js-mch365-placement-canvas').length > 0){
                mch365.placementTool.jPlacementCanvas = jQuery('.js-mch365-placement-canvas');
                mch365.placementTool.guid = mch365.placementTool.get.guid();
                mch365.placementTool.set.canvas();
                mch365.placementTool.generate.tiles();
                mch365.placementTool.bindEvents();
            }
        },
        bindEvents: function(){
            mch365.placementTool.jPlacementCanvas.on('mouseover', '.js-mch365-canvas-tile', function(event){
                if(jQuery(event.currentTarget).is(':empty')){
                    mch365.placementTool.generate.innerTiles(event);
                }
                return false;
            });

            mch365.placementTool.jPlacementCanvas.on('mouseleave', '.js-mch365-canvas-tile', function(event){
                if(jQuery(event.currentTarget).find('li.js-reserved').length === 0 && !jQuery(event.currentTarget).closest('.js-mch365-canvas-tile').hasClass('js-clicked')){
                    mch365.placementTool.remove.innerTiles(event)
                }
                return false;
            });

            mch365.placementTool.jPlacementCanvas.on('click', '.js-mch365-innertile', function(event){
                mch365.placementTool.jLastClickedTile = jQuery(event.currentTarget);
                mch365.placementTool.jLastClickedTile.closest('.js-mch365-canvas-tile').addClass('js-clicked');
                mch365.placementTool.set.reserveTile(event);
                if(jQuery(event.currentTarget).is(':empty')) {
                    //mch365.placementTool.generate.innerTiles( event );
                }
                return false;
            });

            jQuery('.js-canvas-zoom-in').on('click', function(event){
                event.preventDefault();
                ++mch365.placementTool.zoom.current;
                mch365.placementTool.zoom.current = mch365.placementTool.zoom.current > mch365.placementTool.zoom.max ? mch365.placementTool.zoom.max : mch365.placementTool.zoom.current;
                mch365.placementTool.set.canvasZoom();
            });

            jQuery('.js-canvas-zoom-out').on('click', function(event){
                event.preventDefault();
                --mch365.placementTool.zoom.current;
                mch365.placementTool.zoom.current = mch365.placementTool.zoom.current < mch365.placementTool.zoom.min ? mch365.placementTool.zoom.min : mch365.placementTool.zoom.current;
                mch365.placementTool.set.canvasZoom();
            });

            console.log(0, 0, mch365.placementTool.jPlacementCanvas.closest('.js-mch365-placement-canvas-container')[0].clientWidth, mch365.placementTool.jPlacementCanvas.closest('.js-mch365-placement-canvas-container')[0].clientHeight);
            //0 0 841 630
            mch365.placementTool.jPlacementCanvas.draggable({
                containment : '#js-mch365-placement-containment',//[-50, -50, 50, 50],//[0, 0, 841, 630],//'.js-mch365-placement-canvas-container'//[ 0, 0, mch365.placementTool.jPlacementCanvas.closest('.js-mch365-placement-canvas-container')[0].clientWidth, mch365.placementTool.jPlacementCanvas.closest('.js-mch365-placement-canvas-container')[0].clientHeight ]// jQuery('.js-mch365-placement-canvas-container')// [ 0, 0, 100, 100 ]//'parent' //[ x1, y1, x2, y2 ].
            });
        },
        generate:{
            tiles: function(){
                var intDevisionVertical = mch365.placementTool.jPlacementCanvas.data('widthCm') / mch365.placementTool.tile.width,
                    intDevisionHorizontal = mch365.placementTool.jPlacementCanvas.data('heightCm') / mch365.placementTool.tile.height;
                for (var indexH = 1; indexH <= intDevisionHorizontal; indexH++) {
                    for (var indexV = 1; indexV <= intDevisionVertical; indexV++) {
                        jQuery('<li>', {
                            id: indexV +'.'+indexH,
                            class: 'js-mch365-canvas-tile mch365-canvas-tile',
                            title: indexV +'.'+indexH
                        }).css({
                            'width': 'calc(100%/'+intDevisionVertical+')',
                            'height': 'calc(100%/'+intDevisionHorizontal+')'
                        }).appendTo(mch365.placementTool.jPlacementCanvas);
                    }
                }

            },
            innerTiles: function(event){
                var jElement = jQuery(event.currentTarget);
                jQuery('<ul>').addClass('mch365-innertile-ul').appendTo(jElement);
                var jUl = jElement.find('ul');
                for (var indexH = 1; indexH <= mch365.placementTool.tile.division.horizontal; indexH++) {
                    for (var indexV = 1; indexV <= mch365.placementTool.tile.division.vertical; indexV++) {
                        jQuery('<li>', {
                            id: jElement.attr('id')+'_' + indexV +'.'+indexH,
                            class: 'js-mch365-innertile mch365-innertile',
                            title: jElement.attr('id')+'_' + indexV +'.'+indexH
                        }).css({
                            'width': 'calc(100%/'+mch365.placementTool.tile.division.vertical+')',
                            'height': 'calc(100%/'+mch365.placementTool.tile.division.horizontal+')'
                        }).appendTo(jUl);
                    }
                }

            }
        },
        remove: {
            innerTiles: function(event){
                jQuery(event.currentTarget).empty();
            }
        },
        get: {
            guid: function()
            {
                var d = new Date().getTime();//Timestamp
                var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16;//random number between 0 and 16
                    if(d > 0){//Use timestamp until depleted
                        r = (d + r)%16 | 0;
                        d = Math.floor(d/16);
                    } else {//Use microseconds since page-load if supported
                        r = (d2 + r)%16 | 0;
                        d2 = Math.floor(d2/16);
                    }
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            }
        },
        set: {
            reserveTile: function(event){
                var jTile = jQuery(event.currentTarget);

                if(jTile.hasClass('reserved')){
                    jTile.removeClass('reserved');
                    jTile.removeData('guid');
                    jQuery('li[data-guid="'+mch365.placementTool.guid+'"]').removeClass('reserved').removeData('guid');
                } else {
                    jQuery('li[data-guid="'+mch365.placementTool.guid+'"]').removeClass('reserved').removeData('guid');
                    jTile.addClass('reserved');
                    jTile.attr('data-guid', mch365.placementTool.guid);
                }
            },
            canvas: function(){
                var intRatio = mch365.placementTool.jPlacementCanvas.data('widthCm') / mch365.placementTool.jPlacementCanvas.data('heightCm');
                mch365.placementTool.jPlacementCanvas.closest('.js-mch365-placement-canvas-container').css({
                    'padding-bottom': 'calc(100%/'+intRatio+')'
                });
                var bgImage = '/Files/Images/MCH365/stand/'+mch365.placementTool.jPlacementCanvas.data('standNumber')+'.svg';
                mch365.placementTool.jPlacementCanvas.css({
                    "background-image": "url('"+bgImage+"')"
                });

                mch365.placementTool.canvas.originalWidth = mch365.placementTool.jPlacementCanvas.width();
                mch365.placementTool.canvas.originalHeight = mch365.placementTool.jPlacementCanvas.height();
                mch365.placementTool.canvas.originalPadding = mch365.placementTool.jPlacementCanvas.data('gutters').split(',');
                mch365.placementTool.set.canvasZoom();
            },
            canvasZoom: function(){
                var strCssPadding = '';
                jQuery.each(mch365.placementTool.canvas.originalPadding, function(intIndex, value){
                    strCssPadding += mch365.placementTool.zoom.current*value+'% ';
                });

                mch365.placementTool.jPlacementCanvas.css({
                    'width': 100*mch365.placementTool.zoom.current + '%',
                    'height': 100*mch365.placementTool.zoom.current + '%',
                    'padding': strCssPadding
                });

                //mch365.placementTool.jPlacementCanvas.draggable('option', 'containment', '#js-mch365-placement-containment');
            }
        }
    };




    mch365.scrollPosition = {
        init: function () {
            var intWindowWidth = jQuery(window).width();

            if (intWindowWidth > e4.settings.breakpoint.lg) {
                var $row = jQuery('.mch365-content-publisher-container .row');
                var rowHeight = $row.innerHeight();

                // Loop through each scrollable column
                jQuery('.content-publisher.column-scroll').each(function (intIndex, column) {
                    var $column = jQuery(column);

                    // Calculate total content height inside the column
                    var contentHeight = 0;
                    $column.find('.mch365-imageontext-custom-container').each(function (_, item) {
                        contentHeight += jQuery(item).outerHeight(true); // includes margins
                    });

                    // Calculate the scroll offset needed to align bottom of content with bottom of row
                    var scrollDistance = rowHeight - contentHeight;

                    // If the column is taller than the row, clamp to 0 (can't scroll "up")
                    if (scrollDistance < 0) scrollDistance = 0;

                    // Animate this column independently, but all use the same trigger range
                    gsap.to(column, {
                        y: scrollDistance,
                        ease: 'sine.inOut',
                        scrollTrigger: {
                            trigger: '.mch365-content-publisher-container', // shared trigger
                            start: 'top top',
                            end: 'bottom bottom',
                            scrub: 1,
                            // markers: true,
                            id: `column-${intIndex}`
                        }
                    });
                });
            }
        }
    };

    mch365.modalForms = {
        init: function(){
            if(jQuery('.js-mch365-modal-form').length > 0){
                e4.require.js( e4.settings.require.jQueryValidate, function () {
                    mch365.modalForms.bindEvents();
                });
            }
        },
        bindEvents: function(){
            jQuery('.js-mch365-modal-form').each(function(intIndex, domModalElement){
                var jModalElement = jQuery(domModalElement),
                    jForm = jModalElement.find('form');

                jModalElement.on('show.bs.modal', function (event) {
                    var jRelatedTarget = jQuery(event.relatedTarget);
                    jModalElement.find('.modal-title').text(jRelatedTarget.data('heading'));
                    jQuery.each(jRelatedTarget.data(), function(key,value){
                        jForm.find('input[name="'+key+'"]').val(value);
                        if(jModalElement.find('[data-content-type="'+key+'"]').length > 0){
                            jModalElement.find('[data-content-type="'+key+'"]').each( function(intIndex,domElement){
                                var jElement = jQuery(domElement),
                                    jElementCloned = jElement.clone(),
                                    html = jElementCloned.html().split('{{'+key+'}}').join(value).split('js-temp-element').join('js-temp-element js-remove-when-closed');
                                jQuery(html).insertAfter(jElement);
                            });
                        }
                    });
                });

                jModalElement.on('shown.bs.modal', function (event) {
                    jModalElement.find('.form-group').first().find('input').focus();
                });

                jModalElement.on('hidden.bs.modal', function (event) {
                    jModalElement.find('.form-group input[type="text"], .form-group textarea').val('');
                    jModalElement.find('form').show();
                    jModalElement.find('.js-mch365-respons-content').hide();
                    jModalElement.find('.js-remove-when-closed').remove();
                });

                jForm.validate( {
                    submitHandler: function ( domForm, event ) {
                        event.preventDefault();
                        var fnDwFormSpamScript = null;
                        fnDwFormSpamScript = e4.data.get( 'forms.dwSpamScripts.' + domForm.id );
                        if ( domForm.elements[ e4.settings.forms.submitPageFieldName ] !== undefined ) {
                            domForm.elements[ e4.settings.forms.submitPageFieldName ].value = location.href;
                        }

                        if ( jQuery.isFunction( fnDwFormSpamScript ) === true ) {
                            fnDwFormSpamScript.call( window, domForm );
                        }
                        mch365.modalForms.submit(jModalElement, domForm, event);
                    }
                } );

                jQuery.each(jModalElement.data(), function(key,value){
                    jForm.find('input[name="'+key+'"]').val(value);
                });
            });
        },
        submit: function(jModalElement, domForm, event){
            var formData = new FormData( domForm );
            mch365.modalForms.ajax( domForm, event, {
                url: jModalElement.data( 'postUrl' ),
                data: formData
            }, function ( jsonData ) {
                jQuery(domForm).hide();
                jModalElement.find('.js-remove-when-closed').remove();
                jModalElement.find('.js-mch365-respons-content').show();
                e4.gtm.pushDataLayer({
                    'event': 'form_indsendt',
                    'formType': jQuery(domForm).find('input[name="type"]').val()
                });
                setTimeout(function () {
                    jModalElement.modal('hide');
                }, 3000);
            } );
        },
        ajax: function ( form, event, objAjaxSettings, fnCallback ) {
            var jqXHR = jQuery.ajax( jQuery.extend( {
                type: 'POST',
                method: 'POST',
                dataType: 'html',
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                cache: false,
                beforeSend: function () {}
            }, objAjaxSettings ) );
            jqXHR.done( function ( data ) {
                if ( typeof fnCallback === 'function' ) {
                    fnCallback( data );
                }
            } );
        }
    };

}() );
